import { Phone, Calendar, Globe, Clock } from "lucide-react";

const benefits = [
  {
    icon: Clock,
    title: "24/7 Call Answering",
    description: "Never miss a call again. CallChat answers every call, day or night, weekends and holidays included.",
  },
  {
    icon: Calendar,
    title: "AI Appointment Booking",
    description: "Automatically schedules appointments directly into your calendar. No double-bookings, no hassle.",
  },
  {
    icon: Globe,
    title: "Multilingual Support",
    description: "Fluent conversations in Dutch, French, and English. Serve your diverse customer base seamlessly.",
  },
  {
    icon: Phone,
    title: "Reduce Missed Calls",
    description: "Stop losing customers to voicemail. Every call gets answered and every lead gets captured.",
  },
];

const Benefits = () => {
  return (
    <section className="py-20 lg:py-28 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            Why Businesses Love <span className="text-gradient">CallChat</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Transform your phone support with AI that works around the clock.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group p-6 rounded-2xl bg-card border border-border hover:border-primary/30 hover:shadow-card transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                <benefit.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-lg font-semibold mb-2">{benefit.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
